import styled from "styled-components";

export const ErrorMarker = styled.span`
  display: inline-block;
  width: 16px; /* Diameter of the circle */
  height: 16px; /* Diameter of the circle */
  background-color: var(
    --ons-color-ruby-red
  ); /* Background color of the circle */
  border: 1px solid var(--ons-color-white); /* Border color and thickness */
  border-radius: 50%; /* Makes the element a circle */
  vertical-align: middle;
  margin-left: 10px;
`;

export const ErrorCount = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 24px; /* Diameter of the circle */
  height: 24px; /* Diameter of the circle */
  background-color: var(
    --ons-color-ruby-red
  ); /* Background color of the circle */
  border: 1px solid var(--ons-color-white); /* Border color and thickness */
  border-radius: 50%; /* Makes the element a circle */
  box-sizing: border-box;

  margin-left: 10px;
  font-size: 14px;
  line-height: 18px;
`;
